import { FormProvider } from 'react-hook-form';
import { useEditBranchForm } from './hooks';
import { EditBranchFormPresentation } from './presentations';

type Props = {
  branchId: number;
};

export const EditBranchForm: React.FC<Props> = ({ branchId }) => {
  const {
    state: { methods, isSubmitDisabled, title },
    actions: { handleSubmit },
  } = useEditBranchForm({ branchId });

  return (
    <FormProvider {...methods}>
      <EditBranchFormPresentation
        isSubmitDisabled={isSubmitDisabled}
        onSubmit={handleSubmit}
        title={title}
      />
    </FormProvider>
  );
};
